import { routes } from "../router/mobile/routes";
import { useLocation, matchRoutes } from "react-router";

export const useCurrentPath = () => {
  const location = useLocation();
  const matchedRoute = matchRoutes(
    Object.entries(routes).map(([key, val]) => ({ path: val.path })),
    location
  );
  const path = matchedRoute?.at(0)?.route.path;
  return path && path !== "*" ? path : null;
};
